<template>
  <chip :payload="getStatus" />
</template>

<script>
import Chip from '@/app/arch/components/global-components/Chip.vue';

export default {
  name: 'HolidayStatusColumn',
  components: { Chip },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    getStatus() {
      return this.value ? {
        color: '#B9F6CA',
        textColor: '#00C853',
        label: 'Ativo',
      } : {
        color: '#FFCDD2',
        textColor: '#C62828',
        label: 'Inativo',
      };
    },
  },
};
</script>

<style>

</style>
